import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { Components } from '.generated/templates/Feature.Components.model';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { Autocomplete } from 'components/helpers/AlgoliaSearch/Autocomplete';
import SearchFacets from 'components/helpers/AlgoliaSearch/SearchFacets';
import SearchResults from 'components/helpers/AlgoliaSearch/SearchResults';
import SearchSort from 'components/helpers/AlgoliaSearch/SearchSort';
import SearchStats from 'components/helpers/AlgoliaSearch/SearchStats';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import { classnames } from 'tailwindcss-classnames';

export type EmployeeBlogListingProps = Sitecore.Override.ComponentBase &
  Components.Articles.Fields.EmployeeBlogListing;

const EmployeeBlogListing = ({ fields }: EmployeeBlogListingProps) => {
  if (!fields) {
    return <MissingDataSource />; // No fields? Exit early
  }
  const placeholdertext = fields.searchbarPlaceholderText?.value || '';
  const noResultshelpText = fields.noResultsHelpText;
  const filters: string[] = [];
  return (
    <LayoutPageSectionShell theme="theme-white">
      <div className={classnames('md:mt-2')}>
        <Autocomplete
          detachedMediaQuery="none"
          openOnFocus
          asSearchBox
          placeholder={placeholdertext}
        />
      </div>
      <div
        className={classnames(
          'flex',
          'flex-col',
          'md:items-center',
          'justify-between',
          'w-full',
          'md:flex-row',
          'pt-3',
          'pb-6',
          'md:py-7'
        )}
      >
        <SearchStats noResultsText={noResultshelpText} />
        <span className={classnames('hidden', 'lg:block')}>
          <SearchSort />
        </span>
      </div>
      <LayoutLeftThirdShell
        left={<SearchFacets filters={filters} />}
        right={<SearchResults dropdownFilters={filters} noResultsHelpText={noResultshelpText} />}
        isSearchPage
      />
    </LayoutPageSectionShell>
  );
};

export default EmployeeBlogListing;
